
import Banner from '../../componentes/Banner';
import Projeto from '../../componentes/Projeto';
import Objetivos from '../../componentes/Objetivos';
import Sobre from '../../componentes/Sobre';
import Ajuda from '../../componentes/Ajuda';
import Footer from '../../componentes/Footer';
import CarouselArtigos from '../../componentes/CarouselArtigos';

export default function Inicio() {
    return (
        <div>
            <Banner />
            <Projeto />
            <Objetivos />
            <CarouselArtigos />
            <Sobre />
            <Ajuda />
            <Footer />
        </div>
    )
}